import DataTableHeading from './DataTableHeading';

class PivotTableHeading {
  constructor(readonly heading: DataTableHeading, readonly sort?: number) {}

  static create(...params: [DataTableHeading, number | undefined]) {
    return new PivotTableHeading(...params);
  }

  static fromServer(h: PivotTableHeading) {
    return new PivotTableHeading(
      DataTableHeading.fromServer(h.heading),
      h.sort,
    );
  }
}

export default PivotTableHeading;
